import { JetView } from 'webix-jet'; // Importing JetView class from webix-jet for creating views
import { allpayments } from 'models/allpayments'; // Importing allpayments model for data handling
import { devConfig } from 'config/config'; // Importing development configuration settings

/**
 * Class representing a view for the betting shop table.
 * @extends JetView
 */
export default class tableBetShopView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        // Retrieve the localization service and its translation function
        const _ = this.app.getService('locale')._;
        // Define the date format based on the application configuration
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat);
        // Preserve the context of 'this' for use in inner functions
        var vthis = this;
        return {
            // Define the main view as a datatable
            view: 'datatable',
            // Unique identifier for the datatable
            id: 'datatable2',
            // CSS classes for styling the datatable
            css: 'webix_header_border webix_data_border',
            // Enable row selection
            select: true,
            // Set height based on screen width
            height: screen.width < 500 ? 250 : 0,
            // Define the columns of the datatable
            columns: [
                {
                    // Column for editing details
                    id: 'detailTittle',
                    header: '',
                    width: 50,
                    height: 25,
                    // Tooltip text for the edit icon
                    tooltip: _('Editar'),
                    // Hide column based on permission configuration
                    hidden: !devConfig.getPermAction('permCompetence', 'Edit'),
                    // CSS class for permission styling
                    css: 'prm-permCompetence',
                    // Template for the edit icon
                    template: function (obj) {
                        return "<span class='webix_icon wxi-close edit'></span>";
                    },
                },
                // Column for ID with sorting enabled
                { id: 'Id', header: 'ID', width: 100, sort: 'int' },
                {
                    // Column for competition ID with localization
                    id: 'CompetitionId',
                    header: _('Competencia'),
                    width: 100,
                    sort: 'int',
                    // Options for competition selection
                    options: [
                        {
                            id: 1,
                            value: _('Intralot'),
                        },
                        {
                            id: 2,
                            value: _('BetCris'),
                        },
                        {
                            id: 3,
                            value: _('ApuestaTotal'),
                        },
                    ],
                },
                // Column for name with localization
                { id: 'Name', header: _('Nombre'), width: 200, sort: 'int' },
                {
                    // Column for description with localization
                    id: 'Description',
                    header: _('Descripción'),
                    width: 200,
                    sort: 'int',
                },
                {
                    // Column for longitude with localization
                    id: 'Longitud',
                    header: _('Longitud'),
                    width: 100,
                    sort: 'int',
                },
                {
                    // Column for latitude with localization
                    id: 'Latitud',
                    header: _('Latitud'),
                    width: 150,
                    sort: 'int',
                },
                {
                    // Column for address with localization
                    id: 'Address',
                    header: _('Dirección'),
                    width: 150,
                    sort: 'int',
                },
                {
                    // Column for creation date with localization and formatting
                    id: 'CreatedDate',
                    header: _('Fecha de Creación'),
                    fillspace: 0,
                    minWidth: 0,
                    width: 180,
                    sort: 'text',
                    format: dateFormat,
                },
            ],
            // Define click event for the edit icon
            onClick: {
                edit: function (euv, id) {
                    // Show the edit window when the edit icon is clicked
                    $$('editwin').show();
                },
            },
            // Enable tooltips for the datatable
            tooltip: true,
            // Enable mathematical operations in the datatable
            math: true,
            // Set data fetching configuration
            loadahead: devConfig.getDefaultDataFetch(),
            // Define the pager for pagination
            pager: 'pagerA',
            // Set the URL for fetching data from the API
            url: devConfig.geturlApi() + 'BetShop/GetBetShopsCompetence',
            // Sample data for the datatable
            data2: [
                {
                    id: '332',
                    Name: 'Punto 1',
                    Email: 'asd@gmail.com',
                    RegionName: 'Colombia',
                    DepartmentName: 'Antioquia',
                    CityName: 'Medellin',
                    CurrencyId: 'PES',
                    Phone: '3334455',
                    Andress: 'CLL 4 # 45 - 78',
                    CreatedDate: '2018',
                    LastLoginDateLabel: '2019',
                    ModifiedLocal: 'Administrador General',
                },
            ],
            // Define event for double-clicking an item
            on: {
                onItemDblClick: (id) => {
                    // Show the edit window if the user has edit permissions
                    if (devConfig.getPermAction('permCompetence', 'Edit')) {
                        $$('editwin').show();
                    }
                },
            },
        }; // Placeholder for the configuration content
    }

    /**
     * Initializes the view and its components.
     * @param {Object} grid - The grid component to be initialized.
     */
    init(grid) {
        // Retrieve the localization service from the app
        const _ = this.app.getService('locale')._;
        // Get the URL for the grid data
        var url = grid.data.url;
        // Preserve the context of 'this' for use in the event handler
        var cthis = this;
        // Initialize an empty filter string
        var filter = '';
        // Listen for the 'betShop:filter' event on the app
        this.on(this.app, 'betShop:filter', (filterData) => {
            // Convert filterData object into an array of entries
            var object = Object.entries(filterData);
            // Initialize an empty string to build the query parameters
            var string1 = '';
            // Iterate over each entry in the filterData
            for (var i = 0; i < object.length; i++) {
                // Check if the value is not an object and not an empty string
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Handle the 'Datepicker' case specifically
                    if (object[i][0] == 'Datepicker') {
                        // Split the date range into start and end dates
                        var date = object[i][1].split(' - ');
                        console.log(date);
                        // Append dateFrom and dateTo to the query string
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        // Append other key-value pairs to the query string
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                    }
                } else {
                    // Handle the case where the value is an object
                    if (typeof object[i][1] === 'object') {
                        // Convert the nested object into an array of entries
                        var object2 = Object.entries(object[i][1]);
                        // Iterate over each entry in the nested object
                        for (var j = 0; j < object2.length; j++) {
                            // Check if the value is not null
                            if (object2[j][1] !== null) {
                                // Handle the 'start' date case
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]);
                                    // Format the start date into a query string
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    // Append the formatted start date to the query string
                                    string1 = string1 + '&' + dateFrom;
                                } else {
                                    // Handle the 'end' date case
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]);
                                        // Format the end date into a query string
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        // Append the formatted end date to the query string
                                        string1 = string1 + '&' + dateTo;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            // Clear the grid before loading new data
            grid.clearAll();
            // Load the grid with the new data based on the constructed URL and query parameters
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1);
            // Update the filter variable with the new query string
            filter = string1;
            // Trigger the 'BetShopMap:reload' event with the new filter string
            cthis.app.callEvent('BetShopMap:reload', [string1]);
        });
        // Attach an event handler for the 'onAfterSort' event of the grid
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            // Load grid data with sorting parameters
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir);
        });

        // Listen for the 'player:select' event from the app
        this.on(this.app, 'player:select', (Id) => {
            // Load grid data based on the selected player ID
            grid.load(grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&FromId=' + Id);
        });

        // Create a popup window for adding a new entry
        var popupAdd = webix.ui({
            view: 'window',
            id: 'addwinCasshier',
            head: {
                view: 'toolbar',
                cols: [
                    // Label for the window title
                    { view: 'label', label: _('Añadir Punto') },
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        // Close the window on icon click
                        click: function () {
                            this.getTopParentView().hide();
                        },
                    },
                ],
            },
            position: 'center', // Center the window on the screen
            modal: true, // Make the window modal
            width: 5000, // Set the width of the window
            body: {
                view: 'form',
                id: 'saveform2', // ID for the form
                elements: [
                    {
                        view: 'combo',
                        label: _('Competidor'), // Label for the combo box
                        placeholder: _('Click para seleccionar '), // Placeholder text
                        name: 'Competition', // Name of the field
                        labelWidth: 150, // Width of the label
                        width: 300, // Width of the combo box
                        options: [
                            { id: 1, value: _('Intralot') },
                            { id: 2, value: _('BetCris') },
                            { id: 3, value: _('Apuesta Total') },
                        ],
                        required: true, // Mark as required
                        invalidMessage: _('Campo Requerido'), // Error message for invalid input
                    },
                    {
                        view: 'text',
                        name: 'Name', // Name of the field
                        label: _('Nombre'), // Label for the text input
                        labelWidth: 150,
                        width: 300,
                        sort: 'int', // Sorting type
                        required: true,
                        invalidMessage: _('Campo Requerido'),
                    },
                    {
                        view: 'text',
                        name: 'Description', // Name of the field
                        label: _('Descripción'), // Label for the text input
                        labelWidth: 150,
                        width: 300,
                        sort: 'int',
                        required: true,
                        invalidMessage: _('Campo Requerido'),
                    },
                    {
                        view: 'richselect',
                        name: 'CountryId', // Name of the field
                        id: 'country', // ID for the field
                        localId: 'Country:combo', // Local ID for the field
                        label: "<span class='icon-language'></span>" + _('País'), // Label with icon
                        hidden: !devConfig.getPermAction('filterByCountry', 'Add'), // Conditional visibility
                        css: 'prm-filterByCountry', // CSS class for styling
                        labelWidth: 150,
                        placeholder: _('Click para seleccionar '),
                        options: [], // Options will be populated dynamically
                        required: true,
                        invalidMessage: _('Campo Requerido'),
                    },
                    {
                        view: 'richselect',
                        name: 'RegionId', // Name of the field
                        id: 'ProvinceRegion', // ID for the field
                        localId: 'ProvinceRegion:combo', // Local ID for the field
                        label: _('Provincia/Región'), // Label for the field
                        placeholder: _('Click para seleccionar '),
                        options: [], // Options will be populated dynamically
                        labelWidth: 150,
                        required: true,
                        invalidMessage: _('Campo Requerido'),
                    },
                    {
                        view: 'richselect',
                        name: 'CityId', // Name of the field
                        id: 'City', // ID for the field
                        localId: 'City:combo', // Local ID for the field
                        label: "<span class='icon-language'></span>" + _('Ciudad'), // Label with icon
                        labelWidth: 150,
                        placeholder: _('Click para seleccionar '),
                        options: [], // Options will be populated dynamically
                        required: true,
                        invalidMessage: _('Campo Requerido'),
                    },
                    {
                        view: 'text',
                        name: 'Latitud', // Name of the field
                        label: _('Latitud'), // Label for the text input
                        labelWidth: 150,
                        width: 300,
                        sort: 'int',
                        required: true,
                        invalidMessage: _('Campo Requerido'),
                    },
                    {
                        view: 'text',
                        name: 'Longitud', // Name of the field
                        label: _('Longitud'), // Label for the text input
                        labelWidth: 150,
                        width: 300,
                        sort: 'int',
                        required: true,
                        invalidMessage: _('Campo Requerido'),
                    },
                    {
                        view: 'text',
                        name: 'Address', // Name of the field
                        label: _('Dirección'), // Label for the text input
                        labelWidth: 150,
                        width: 300,
                        sort: 'int',
                        required: true,
                        invalidMessage: _('Campo Requerido'),
                    },
                    {
                        cols: [
                            {
                                view: 'button',
                                value: _('Cancelar'), // Label for the cancel button
                                // Close the window and reset form values on click
                                click: function () {
                                    this.getTopParentView().hide();
                                    $$('saveform2').setValues($$('saveform2').getCleanValues());
                                },
                            },
                            {
                                view: 'button',
                                type: 'form', // Button type for form submission
                                value: _('Guardar'), // Label for the save button
                                // Handle form submission on click
                                click: function ($e) {
                                    var values = $$('saveform2').getValues(); // Get form values
                                    if ($$('saveform2').validate()) {
                                        // Validate form
                                        webix
                                            .ajax()
                                            .headers({
                                                'Content-type': 'application/json', // Set content type for the request
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'es/BetShop/SaveBetshopCompetence', // API endpoint
                                                values, // Data to send
                                                {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        // Handle error response
                                                        webix.message({
                                                            title: _('¡Error!'),
                                                            type: 'alert-error',
                                                            text: _('Error'),
                                                        });
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        text = JSON.parse(text); // Parse response
                                                        if (text.HasError) {
                                                            // Check for errors in response
                                                            webix.message({
                                                                title: _('¡Error!'),
                                                                type: 'alert-error',
                                                                text: text.AlertMessage,
                                                            });
                                                        } else {
                                                            // Success message
                                                            webix.message(_('Punto de venta Agregado'));
                                                            grid.clearAll(); // Clear grid data
                                                            // Reload grid data
                                                            grid.load(
                                                                url + '?start=0&count=' + grid.data.$pagesize + filter,
                                                            );
                                                        }
                                                    },
                                                },
                                            );
                                        $$('saveform2').setValues(
                                            $$('saveform2').getCleanValues(), // Reset form values
                                        );
                                        this.getTopParentView().hide(); // Close the window
                                    } else {
                                        // Show error message if validation fails
                                        webix.message({
                                            title: _('¡Error!'),
                                            type: 'alert-error',
                                            text: _('Completa los campos...'),
                                        });
                                    }
                                },
                            },
                        ],
                    },
                ],
                elementsConfig: {
                    on: {
                        // Validate fields on change
                        onChange: function () {
                            this.validate();
                        },
                    },
                },
            },
        });
        // Create a popup window for editing a point
        var popupEdit = webix.ui({
            view: 'window', // Define the view type as a window
            id: 'editwin', // Unique identifier for the window
            head: {
                view: 'toolbar', // Toolbar at the top of the window
                cols: [
                    { view: 'label', label: _('Editar Punto') }, // Label for the window title
                    {
                        view: 'icon', // Close icon in the toolbar
                        icon: 'wxi-close', // Icon type
                        click: function () {
                            // Click event to close the window
                            this.getTopParentView().hide(); // Hide the window
                        },
                    },
                ],
            },
            position: 'center', // Center the window on the screen
            modal: true, // Make the window modal
            width: 5000, // Set the width of the window
            body: {
                view: 'form', // Define the body as a form
                id: 'saveform', // Unique identifier for the form
                elements: [
                    {
                        view: 'text', // Text input for Id
                        name: 'Id', // Name of the input field
                        label: 'Id', // Label for the input field
                        disabled: true, // Disable the input field
                        labelWidth: 150, // Width of the label
                        width: 300, // Width of the input field
                        sort: 'int', // Sorting type
                    },
                    {
                        view: 'combo', // Dropdown for selecting competition
                        label: _('Competencia'), // Label for the dropdown
                        name: 'CompetitionId', // Name of the input field
                        labelWidth: 150, // Width of the label
                        width: 300, // Width of the dropdown
                        options: [
                            // Options for the dropdown
                            {
                                id: 1, // Option id
                                value: _('Intralot'), // Option value
                            },
                            {
                                id: 2, // Option id
                                value: _('BetCris'), // Option value
                            },
                            {
                                id: 3, // Option id
                                value: _('Apuesta Total'), // Option value
                            },
                        ],
                    },
                    {
                        view: 'text', // Text input for Name
                        name: 'Name', // Name of the input field
                        label: _('Nombre'), // Label for the input field
                        labelWidth: 150, // Width of the label
                        width: 300, // Width of the input field
                        sort: 'int', // Sorting type
                    },
                    {
                        view: 'text', // Text input for Description
                        name: 'Description', // Name of the input field
                        label: _('Descripción'), // Label for the input field
                        labelWidth: 150, // Width of the label
                        width: 300, // Width of the input field
                        sort: 'int', // Sorting type
                    },
                    {
                        view: 'text', // Text input for Latitude
                        name: 'Latitud', // Name of the input field
                        label: _('Latitud'), // Label for the input field
                        labelWidth: 150, // Width of the label
                        width: 300, // Width of the input field
                        sort: 'int', // Sorting type
                    },
                    {
                        view: 'text', // Text input for Longitude
                        name: 'Longitud', // Name of the input field
                        label: _('Longitud'), // Label for the input field
                        labelWidth: 150, // Width of the label
                        width: 300, // Width of the input field
                        sort: 'int', // Sorting type
                    },
                    {
                        view: 'text', // Text input for Address
                        name: 'Address', // Name of the input field
                        label: _('Dirección'), // Label for the input field
                        labelWidth: 150, // Width of the label
                        width: 300, // Width of the input field
                        sort: 'int', // Sorting type
                    },
                    {
                        cols: [
                            // Button container
                            {
                                view: 'button', // Cancel button
                                value: _('Cancelar'), // Button label
                                click: function () {
                                    // Click event for cancel button
                                    this.getTopParentView().hide(); // Hide the window
                                    $$('saveform').setValues(
                                        // Reset form values
                                        $$('saveform').getCleanValues(),
                                    );
                                },
                            },
                            {
                                view: 'button', // Save button
                                type: 'form', // Button type
                                value: _('Guardar'), // Button label
                                click: function ($e) {
                                    // Click event for save button
                                    var values = $$('saveform').getValues(); // Get form values
                                    webix // Make an AJAX request to save the data
                                        .ajax()
                                        .headers({
                                            'Content-type': 'application/json', // Set content type
                                        })
                                        .post(
                                            devConfig.geturlApi() + // API URL
                                                'es/BetShop/SaveBetshopCompetence',
                                            values, // Data to send
                                            {
                                                error: function (
                                                    // Error callback
                                                    text,
                                                    data,
                                                    XmlHttpRequest,
                                                ) {
                                                    webix.message(_('Error! ')); // Show error message
                                                },
                                                success: function (
                                                    // Success callback
                                                    text,
                                                    data,
                                                    XmlHttpRequest,
                                                ) {
                                                    webix.message(
                                                        // Show success message
                                                        _('Punto de venta Actualizado'),
                                                    );
                                                    grid.clearAll(); // Clear the grid data
                                                    grid.load(
                                                        // Reload the grid with updated data
                                                        url + '?start=0&count=' + grid.data.$pagesize + filter,
                                                    );
                                                },
                                            },
                                        );
                                    $$('saveform').setValues(
                                        // Reset form values
                                        $$('saveform').getCleanValues(),
                                    );
                                    this.getTopParentView().hide(); // Hide the window
                                },
                            },
                        ],
                    },
                ],
            },
        });
        // Bind the 'saveform' to the 'datatable2' for data handling
        $$('saveform').bind($$('datatable2'));

        // Event listener for the 'addBetShop:button' event
        this.on(this.app, 'addBetShop:button', (filter) => {
            // Clear any existing validation errors on 'saveform2'
            $$('saveform2').clearValidation();
            // Show the popup for adding a new bet shop
            popupAdd.show();
        });

        // Initiate an AJAX request to fetch agent countries
        webix
            .ajax()
            .headers({
                // Set the content type to JSON for the request
                'Content-type': 'application/json',
            })
            .post(devConfig.geturlApi() + 'Agent/GetAgentCountries', '', {
                // Callback function for handling errors
                error: function (text, data, XmlHttpRequest) {
                    // Display an error message if the request fails
                    webix.message(_('Error! '));
                },
                // Callback function for handling successful responses
                success: function (text, data, XmlHttpRequest) {
                    // Parse the response text and replace keys for consistency
                    var data = JSON.parse(
                        text
                            .replace(/"Id"/g, '"id"') // Normalize 'Id' to 'id'
                            .replace(/"Name"/g, '"value"'), // Normalize 'Name' to 'value'
                    );
                    // Get the list of options for the 'country' dropdown
                    var optionsProvinceRegions = $$('country').getList();
                    // Clear all existing options in the dropdown
                    optionsProvinceRegions.clearAll();
                    // Parse and add new data to the dropdown
                    optionsProvinceRegions.parse(data.Data);
                },
            });
        // Attach an event listener for the 'onChange' event of the 'country' dropdown
        $$('country').attachEvent('onChange', function (newv, oldv) {
            // Retrieve the selected country's departments based on the new value
            var optionscountries = this.getList().getItem(newv);
            // Get the list of province regions associated with the 'ProvinceRegion' dropdown
            var optionsProvinceRegions = $$('ProvinceRegion').getList();
            // Clear all existing options in the province regions list
            optionsProvinceRegions.clearAll();
            // Populate the province regions list with the departments of the selected country
            optionsProvinceRegions.parse(optionscountries.departments);
            // Reset the value of the 'ProvinceRegion' dropdown
            $$('ProvinceRegion').setValue('');
            // Reset the value of the 'City' dropdown
            $$('City').setValue('');
        });

        // Attach an event listener for the 'onChange' event of the 'ProvinceRegion' dropdown
        $$('ProvinceRegion').attachEvent('onChange', function (newv, oldv) {
            // Retrieve the selected province region's cities based on the new value
            var optionsProvinceRegions = this.getList().getItem(newv);
            // Get the list of cities associated with the 'City' dropdown
            var optionsCity = $$('City').getList();
            // Check if the 'ProvinceRegion' dropdown has a selected value
            if ($$('ProvinceRegion').getValue() != '') {
                // Clear all existing options in the city list
                optionsCity.clearAll();
                // Populate the city list with the cities of the selected province region
                optionsCity.parse(optionsProvinceRegions.cities);
                // Reset the value of the 'City' dropdown
                $$('City').setValue('');
            }
        }); // Placeholder for the initialization content
    }
}

// FILE DOCUMENTED
